import React from 'react';
import { FormattedMessage } from 'react-intl';
import { isEqual, findIndex } from 'lodash';
import utils from '../../../../../utils/utilities';
import api from '../../Dashboard.api';
import RiskEntityPESTLE from './RiskEntityPESTLE';

class TrendingEntitiesPod extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            companies: [],
            companiesScores: [],
            loading:   true,
            riskAngle: null
        };

        this.loadData = this.loadData.bind(this);
        this.getFilterMessageId = this.getFilterMessageId.bind(this);
    }

    componentWillMount() {
        this.loadData(this.props.days, this.props.entities, this.props.pestle, this.props.risk, this.props.language);
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.days !== nextProps.days ||
            !isEqual(this.props.pestle, nextProps.pestle)||
            !isEqual(this.props.risk, nextProps.risk)||
            !isEqual(this.props.language, nextProps.language)||
            !isEqual(this.props.entities, nextProps.entities)) {
            this.loadData(nextProps.days, nextProps.entities, nextProps.pestle, nextProps.risk, nextProps.language);
        }
    }

    loadData(days, entities, pestle, risk, language) {
        this.setState({loading: true});

        let catFilter = utils.buildDashboardFilter(entities, risk, pestle, days, language);
        api
            .getElasticTrendingEntitiesPestleScores(catFilter)
            .then((res)=>{

                let companies = [];
                let scores = [];
                for (let i=0; i<res.length; i++) {
                    scores.push(res[i]);
                }
                this.setState({
                    companies: res,
                    companiesScores: scores,
                    loading:false
                });
            })
            .catch((error) => {
                utils.logError(error, 'TrendingEntitiesPod.loadData():');
                this.setState({loading: false});
                this.props.loadComplete(null);
                //xhr.handleAllErrors(error);
            });
    }

    getFilterMessageId()  {
        switch (this.props.days.toString()) {
            case '1':
                return 'Dashboard_Charts_UIText_dashboard.entityPod.filter1Day';
            case '7':
                return 'Dashboard_Charts_UIText_dashboard.entityPod.filter7Days';
            default:
                return 'Dashboard_Charts_UIText_dashboard.entityPod.filter30Days';
        }
    };

    getFilterMessageIdOverlay()  {
        switch (this.props.days.toString()) {
            case '1':
                return 'Dashboard_Charts_UIText_dashboard.podOverlay.filter1Day';
            case '7':
                return 'Dashboard_Charts_UIText_dashboard.podOverlay.filter7Days';
            default:
                return 'Dashboard_Charts_UIText_dashboard.podOverlay.filter30Days';
        }
    };

    render() {
        return (

            <div className="dashboard-page__trending--entities">
                <div className="entities-title">
                    <FormattedMessage id={this.getFilterMessageId()} />
                </div>

                {this.state.loading ? <div className="inline-spinner"></div> :
                    <div className="entities-body">
                        <table>
                        {this.state.companies.length !== 0 ?
                            <thead>
                                <tr>
                                    <th className="entity-title">
                                        <FormattedMessage id="Dashboard_Charts_UIText_dashboard.entity" />
                                    </th>
                                    <th className="article-sum">
                                        <FormattedMessage id="Dashboard_Charts_UIText_dashboard.articles" />
                                    </th>
                                    <th>
                                        <FormattedMessage id="General_CoreFunctionality_UIText_general.political" />
                                    </th>
                                    <th>
                                        <FormattedMessage id="General_CoreFunctionality_UIText_general.economic" />
                                    </th>
                                    <th>
                                        <FormattedMessage id="General_CoreFunctionality_UIText_general.social" />
                                    </th>
                                    <th>
                                        <FormattedMessage id="General_CoreFunctionality_UIText_general.technological" />
                                    </th>
                                    <th>
                                        <FormattedMessage id="General_CoreFunctionality_UIText_general.legal" />
                                    </th>
                                    <th>
                                        <FormattedMessage id="General_CoreFunctionality_UIText_general.environmental" />
                                    </th>
                                </tr>
                            </thead>
                            : null}

                            <tbody>
                                {this.state.companies.length !== 0 ?
                                    this.state.companies.map(company => {
                                        let cc=null;
                                        let idx = findIndex(this.state.companiesScores, {"_id": company.id});
                                        if (idx !== -1) {
                                            cc = this.state.companiesScores[idx];
                                        }
                                        return(
                                            <RiskEntityPESTLE
                                                key={"trending-entity-" + company.id}
                                                company={company}
                                                companyScore={cc}
                                                days={this.props.days}
                                                pestle={this.props.pestle}
                                                risk={this.props.risk} />
                                            )
                                    }
                                    ) :
                                    <tr className="empty-entities">
                                        <td colSpan="8">
                                            <FormattedMessage
                                                id="General_CoreFunctionality_UIText_general.nothingToDisplay" />
                                        </td>
                                    </tr>}
                            </tbody>
                        </table>

                    </div>

                }

            </div>
        );
    }

}

export default TrendingEntitiesPod;


// WEBPACK FOOTER //
// ./src/scripts/pages/StartPage/Dashboard/components/TrendingEntitiesPodSingleQuery/TrendingEntitiesPod.jsx